import React from 'react';
import PropTypes from 'prop-types';
import EditButton from 'components/button/EditButton';
import styled from 'styled-components';
import { ImageIcon } from 'assets/materialIcons/materialIcons';

const StyledInnerColumn = styled.div`
    box-sizing: border-box;
    position: relative;
    display: flex;
    flex-direction: column;
    margin: 0 10px;
    flex: 1;

    &:first-child {
        margin-left: 0;
    }

    &:last-child {
        margin-right: 0;
    }
`;

const StyledTitle = styled.div`
    box-sizing: border-box;
    position: relative;
    font-size: 14px;
    text-transform: uppercase;
`;

const StyledActions = styled.div`
    position: absolute;
    top: 0;
    right: 0;
`;

const InnerColumn = (props) => {
    const { children, editRoute, size, title } = props;

    return (
        <StyledInnerColumn size={ size }>
            { editRoute &&
                <StyledActions>
                    <EditButton
                        icon={ <ImageIcon /> }
                        label=''
                        style={ { minWidth: '40px' } }
                        url={ editRoute }
                    />
                </StyledActions>
            }

            { title &&
                <StyledTitle>{ title }</StyledTitle>
            }

            { children }
        </StyledInnerColumn>
    );
};

InnerColumn.defaultProps = {
    size: null,
    title: null,
};

InnerColumn.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.element,
    ]),
    editRoute: PropTypes.string,
    size: PropTypes.number,
    title: PropTypes.string,
};

export default InnerColumn;



// WEBPACK FOOTER //
// ./src/components/ui/show/InnerColumn.js